<template>
  <div class="v-container page-menu">
    <div class="v-page-header">平台账号管理</div>
    <div class="v-header tool-bar">
      <el-button type="primary" size="small" @click="add">
        <i class="el-icon-plus"></i>
        添加账号
      </el-button>
      <div>
        <el-input v-model="keyword" class="v-form-item" size="mini" placeholder="请输入账号" style="width: 200px"></el-input>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table :data="lists" border size="small" style="width: 100%">
        <el-table-column prop="id" label="ID" width="50" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column prop="login_name" label="账号" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="v-color-green">启用</span>
            <span v-if="scope.row.status == 2" class="v-color-red">禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip v-if="userInfo.type == 1" effect="dark" content="角色设置" placement="top">
              <el-button @click="setRole(scope.row)" type="default" size="min">
                <i class="iconfont icon-users"></i>
              </el-button>
            </el-tooltip>
            <el-button @click="edit(scope.row)" type="default" size="min" icon="el-icon-edit"></el-button>
            <el-button @click="del(scope.row)" :loading="scope.row.loading" type="default" size="min" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getList(page);
          }
        "
        :current-page.sync="page"
        :total="total"
      ></el-pagination>
    </div>
    <AccountAddEdit
      v-if="isShowAddEdit"
      :isShow.sync="isShowAddEdit"
      @success="
        (page) => {
          getList(page);
        }
      "
      :row="row"
    />
  </div>
</template>

<script>
import AccountAddEdit from './components/account-add-edit';

export default {
  name: 'permissionaccount',
  components: {
    AccountAddEdit,
  },
  data() {
    return {
      lists: [], // table数据
      loading: false, // 页面loading
      row: null, // 操作时row
      userInfo: this.$store.getters.userInfo,
      total: 0,
      page: 1,
      page_size: 10,
      keyword: '',
      isShowAddEdit: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(page, page_size) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.userAdmin.getAdmin({
          page: this.page,
          page_size: this.page_size,
          keyword: this.keyword,
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (ex) {
        console.error(ex);
      }
      this.loading = false;
    },

    // 添加
    add() {
      this.row = null;
      this.isShowAddEdit = true;
    },

    // 修改
    edit(row) {
      this.row = row;
      this.isShowAddEdit = true;
    },

    // 删除
    async del(row) {
      try {
        await this.$confirm('确认删除么?', '提示', { type: 'warning' });
        row.loading = true;
        let res = await this.api.userAdmin.deleteAdmin({ id: row.id });
        this.$message.success(res.message);
        row.loading = false;
        this.getList();
      } catch (e) {
        console.error(e);
      }
      row.loading = false;
    },

    reset() {
      this.keyword = '';
      this.getList(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.tool-bar {
  padding: 0 0 15px 0;
}

.v-header {
  display: flex;
  justify-content: space-between;
}
</style>
